import TemplateNames from './TemplateNames';

export default {
  title: 'E-mails automatisés',
  labels: {
    empty_list: 'Aucun modèle trouvé',
    load_failed: 'Impossible de charger vos e-mails automatisés. Veuillez recharger la page ou contacter le support.',
    on: 'Activé',
    off: 'Désactivé',
  },
  fields: {
    name: 'Nom',
    messages_delivered: 'Messages délivrés',
    open_rate: "Taux d'ouverture",
    click_rate: 'Taux de clic',
    status: 'Statut',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Impossible de mettre à jour le statut',
    failed_to_load_data: 'Impossible de charger les données',
  },
};
